export const mutations = {
    setCrmProposta(state, CrmProposta) {
        state.crmProposta = CrmProposta
    },
    setCrmPropostas(state, CrmPropostas) {
        state.crmPropostas = CrmPropostas
    },
    addCrmProposta(state, data){
        state.crmPropostas.push(data)
    },
    removeCrmProposta(state, data){
        let index = state.crmPropostas.data.map(x => x.id).indexOf(data.id);
        state.crmPropostas.data.splice(index, 1)
    },
    setModalCadastroCrmProposta(state, status) {
        state.modalCadastroCrmProposta = status
    },
    setModalVisualizarCrmProposta(state, status) {
        state.modalVisualizarCrmProposta = status
    },
    setModalExcluirCrmProposta(state, status) {
        state.modalExcluirCrmProposta = status
    },
    setModalFinalizarCrmProposta(state, status) {
        state.modalFinalizarCrmProposta = status
    },
}

export default {}